import React from 'react';
import {Route} from 'found';

import Layout from './views/layout';

import Home from './views/home';
import wizardRoutes from './views/wizard/routes';
import Help from './views/help';

import PhyloCanvas from './views/phylocanvas';
import DataSheet from './views/datasheet';
import gSheet from './views/gsheet';


const routes = (
  <Route path="/" Component={Layout}>
    <Route Component={Home} />
    <Route path="phylocanvas" Component={PhyloCanvas} />
    <Route path="datasheet" Component={DataSheet} />
    <Route path="gsheet" Component={gSheet} />
    <Route path="help" Component={Help} />
    {wizardRoutes}
  </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js